import { ESortOrder } from "@domains/utils/sort";
import React, { useState } from "react";
import "@frameworks/web/stylesheets/components/Reports/HoldingReports/SortDrop.scss";
const CommonSortDrop = ({ sortKeyDisplayState, OrderBy, setOrderBy, sortByFilters, sortByFunction, setSortByFilters, resetSort, nestedList, showCustomFooter, parentClass, themeClass, }) => {
    const [sortState, setSortState] = useState(sortByFilters);
    const [id, setId] = useState(0);
    const setSortOrder = (idx, key, value) => {
        setId(idx);
        let tempData = sortState.map((val) => {
            return Object.assign({}, val);
        });
        tempData[idx].order =
            value === ESortOrder.DESC ? ESortOrder.ASC : ESortOrder.DESC;
        tempData = tempData.map((value, id) => {
            if (id !== idx)
                value.order = ESortOrder.UNCHANGED;
            return value;
        });
        setSortState(tempData);
    };
    const SingleSort = (val, idx) => {
        return (React.createElement("li", { key: idx, onClick: () => setSortOrder(idx, val.displayName, val.order), className: sortState[idx].order === 0 ? "dark-grey" : "light-blue" },
            React.createElement("label", null, val.displayName),
            React.createElement("span", { className: "bodylist-right" },
                React.createElement("p", { className: "light-right " +
                        (sortState[idx].order === 0 ? "light-grey" : "light-blue") }, sortKeyDisplayState[val.displayName][val.order === ESortOrder.ASC ? "asc" : "desc"]),
                val.order == ESortOrder.ASC ? (React.createElement("span", null,
                    React.createElement("i", { className: "edel-icon-point-arrow-up" }))) : (React.createElement("span", null,
                    React.createElement("i", { className: "edel-icon-point-arrow-down" }))))));
    };
    return (React.createElement("div", { className: `${themeClass !== null && themeClass !== void 0 ? themeClass : "sort-drop"} ${parentClass ? parentClass : null}` },
        React.createElement("div", { className: "sort-drop-body" },
            React.createElement("ul", { className: "sort-drop-bodylist" },
                nestedList && nestedList.list.length > 0 && (React.createElement("div", { className: "nested-list" },
                    React.createElement("label", { className: "EncodeSans_14_500 txt_blackOne1" }, nestedList.title),
                    nestedList.list.map((val, idx) => {
                        return SingleSort(val, idx);
                    }))),
                sortState.map((val, idx) => {
                    return SingleSort(val, idx);
                }))),
        showCustomFooter ? (showCustomFooter) : (React.createElement("div", { className: "sort-drop-footer" },
            React.createElement("input", { className: `reset-button`, onClick: resetSort, type: "button", value: "Reset" }),
            React.createElement("input", { className: `filter-button`, onClick: () => sortByFunction(id, sortState), type: "button", value: "Apply" })))));
};
export default CommonSortDrop;
